export const formatAxisLabel = (
  dateString: string | undefined,
  totalItems: number,
  index: number
): string => {
  const SHORT_DURATION_DATA_POINTS_LENGTH = 15;

  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  if (totalItems <= SHORT_DURATION_DATA_POINTS_LENGTH) {
    if (index % 2 !== 0) return "";

    return date.toLocaleString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } else {
    return date.toLocaleString("en-US", {
      month: "short",
      year: "2-digit",
    });
  }
};
